import { render } from "./StudentSidebar.vue?vue&type=template&id=07f84704&scoped=true"
import script from "./StudentSidebar.vue?vue&type=script&lang=js"
export * from "./StudentSidebar.vue?vue&type=script&lang=js"

import "./StudentSidebar.vue?vue&type=style&index=0&id=07f84704&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src3444732531/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07f84704"]])

export default __exports__